import { httpClient } from '@/Common/api/http_client';

// =========================================
// Merchant Specific APIs starts
/**
 *
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getMerchantCountries(page, limit) {
  page = (page === null || page === undefined) ? 1 : page;
  limit = (limit === null || limit === undefined) ? 20 : limit;
  return httpClient.get(`/countries?page=${page}&limit=${limit}`);
}

/**
 *
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getMerchantStates(countryId) {
  return httpClient.get(`/countries/${countryId}/states`);
}

/**
 *
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getMerchantCities(stateId) {
  return httpClient.get(`/states/${stateId}`);
}

/**
 *
 * @param countryId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function deleteMerchantCountry(countryId) {
  return httpClient.delete(`/countries/${countryId}`);
}

/**
 *
 * @param countryId
 * @param country
 * @returns {Promise<AxiosResponse<T>>}
 */
export function updateMerchantCountry(countryId, country) {
  return httpClient.put(`/countries/${countryId}`, country);
}

// Merchant Specific APIs ends
// =========================================
